import React, { useState } from 'react';

const Sidebar = React.memo(({ onCategoryChange, onSortChange, clearSearch }) => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [sort, setSort] = useState('price-low');

  const categories = ['All', 'Rings', 'Earrings', 'Necklaces', 'Bracelets'];

  const handleCategory = (category) => {
    setSelectedCategory(category);
    onCategoryChange(category);

    // ✅ Clear search ONLY when "All" is selected
    if (category === 'All' && typeof clearSearch === 'function') {
      clearSearch();
    }
  };

  const handleSort = (e) => {
    setSort(e.target.value);
    onSortChange(e.target.value);
  };

  return (
    <aside
      style={{
        width: '250px',
        padding: '1.5rem',
        background: '#fff',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        borderRadius: '8px',
        margin: '2rem 1rem 2rem 2rem',
        position: 'sticky',
        top: '100px',
        height: 'fit-content',
      }}
    >
      <h3>Categories</h3>

      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {categories.map((category) => (
          <li
            key={category}
            onClick={() => handleCategory(category)}
            style={{
              cursor: 'pointer',
              padding: '0.5rem 0',
              color:
                selectedCategory === category ? '#d4af37' : '#333',
              fontWeight:
                selectedCategory === category ? '600' : '400',
              transition: 'color 0.3s ease',
            }}
          >
            {category}
          </li>
        ))}
      </ul>

      <h3 style={{ marginTop: '2rem' }}>Sort By</h3>

      <select
        value={sort}
        onChange={handleSort}
        style={{
          width: '100%',
          padding: '0.5rem',
          border: '1px solid #ddd',
          borderRadius: '4px',
          background: '#f9f9f9',
          color: '#333',
        }}
      >
        <option value="price-low">Price: Low to High</option>
        <option value="price-high">Price: High to Low</option>
        <option value="name">Name: A–Z</option>
      </select>
    </aside>
  );
});

export default Sidebar;
